import React from 'react';
import Ap from "../../../assets/images/ap.png";
import Wifi2 from "../../../assets/images/wifi2.png";
import Wifi2Security from "../../../assets/images/wifi2Security.png";
import Wifi5 from "../../../assets/images/wifi5.png";
import Wifi5Security from "../../../assets/images/wifi5Security.png";
import Reiniciar from "../../../assets/images/reiniciar.png";
import Rede4 from "../../../assets/images/rede4.fw.png";

import './styles.css';

const ModoAp = () => {


    return (
        <>
            <div className='content'>
                    <h1>Cenário III modo AP</h1>
                <div>
                    <img src={Rede4} alt="Ap" />
                </div>
                <div className="ap">
                    <p>Configure o Modo de Operação</p>
                    <img src={Ap} alt="Ap" />
                </div>
                <br /><br />
                
                <p>Configurando o SSID da Wi-FI 2.4GHz</p>
                <br />
                <div className="wifi2">
                    <img src={Wifi2} alt="wifi2" />
                </div>
                <br />
                <p>Configurando a Segurançada Wi-FI 2.4GHz</p>
                <div className="wifi2">
                    <img src={Wifi2Security} alt="wifi2" />
                </div>
                <br />
                <p>Configurando o SSID da Wi-FI 5GHz</p>
                <div className="wifi5">
                    <img src={Wifi5} alt="wifi5" />
                </div>
                <br />
                <p>Configurando a Segurança da Wi-FI 5GHz</p>
                <div className="wifi5">
                    <img src={Wifi5Security} alt="wifi5" />
                </div>
                <br />
                
                <p>Reinicie o roteador, conecte o cabo de rede na porta 1 da ONU na porta WAN do roteador. Realize um teste de navagação com o celular para verificar se as configurações foram aplicadas corretamente.</p>
                <div className="dns">
                    <img src={Reiniciar} alt="dns" />
                </div>
            </div>
        </>
    );
};

export default ModoAp;
